module.exports = __webpack_public_path__ + "static/media/deleteRowTable.5c6c190e.svg";